export const CLIENT_LOGIN_REQUETTE = "CLIENT_LOGIN_REQUETTE";

export const CLIENT_LOGIN_SUCCES = "CLIENT_LOGIN_SUCCES";
export const CLIENT_LOGIN_ECHEC = "CLIENT_LOGIN_ECHEC";
export const CLIENT_LOGIN_RESET = "CLIENT_LOGIN_RESET";

export const CLIENT_LOGOUT = "CLIENT_LOGOUT";

export const CLIENT_LISTE_SUCCES = "CLIENT_LISTE_SUCCES";
export const CLIENT_LISTE_ECHEC = "CLIENT_LISTE_ECHEC";

export const CLIENT_CODE_SUCCES = "CLIENT_CODE_SUCCES";
export const CLIENT_CODE_ECHEC = "CLIENT_CODE_ECHEC";
export const CLIENT_CODE_REQUETTE = "CLIENT_CODE_REQUETTE";
export const CLIENT_CODE_RESET = "CLIENT_CODE_RESET";

export const CLIENT_CREE_SUCCES = "CLIENT_CREE_SUCCES";
export const CLIENT_CREE_ECHEC = "CLIENT_CREE_ECHEC";
export const CLIENT_CREE_REQUETTE = "CLIENT_CREE_REQUETTE";
export const CLIENT_CREE_RESET = "CLIENT_CREE_RESET";

export const CLIENT_SERV = "CLIENT_SERV";

export const PERSIST_TRUE = "PERSIST_TRUE";
export const PERSIST_FALSE = "PERSIST_FALSE";

export const FCM_CLI_SUCCES = "FCM_CLI_SUCCES";
export const FCM_CLI_ECHEC = "FCM_CLI_ECHEC";
export const FCM_CLI_REQUETTE = "FCM_CLI_REQUETTE";
